export const toBRL = (value)=> value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})